/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * DivisionArray.tsx - Division array hint component.
*/

import { StyleSheet, useWindowDimensions, View } from 'react-native';
import DivisionArrayElement from './DivisionArrayElement';

// Use 14 counters to ensure there is always space in a 12x12 array to allow for padding
const HINT_SCREEN_INSET = 0.9;
const HINT_VERTICAL_SPACE = 0.8;
const HINT_PADDING = 0.9;
const COL_MARGIN = 8;

interface DivisionArrayProps {
  numCols: number,
  numRows: number
}

const DivisionArray = ({numCols, numRows}: DivisionArrayProps) => {

  const windowDimensions = useWindowDimensions();
  const rows = [];
  const cols = [];

  // Calculate the size of the array element by finding the smallest
  // ratio between screen width and number of columns or screen height and number of rows.
  const useableHeight = Math.floor(windowDimensions.height * HINT_SCREEN_INSET * HINT_VERTICAL_SPACE * HINT_PADDING);
  const elementHeight = Math.floor( useableHeight / numRows) - COL_MARGIN;
  const usableWidth = Math.floor(windowDimensions.width * HINT_SCREEN_INSET * HINT_PADDING);
  const elementWidth = Math.floor( usableWidth / numCols) - COL_MARGIN;
  const elementSize = Math.min(elementHeight, elementWidth);

  for (let i = 0; i < numRows; i++) {
    const color = 'red';
    rows.push(
      <DivisionArrayElement key={`element${i}`} width={elementSize} height={elementSize} color={color}/>
    );
  }

  for (let i = 0; i < numCols; i++) {
    cols.push(
      <View style={styles.arrayRow} key={'colNum'+i}>
        {rows}
      </View>
    );
  }

  return (
    <View style={styles.array}>
      {cols}
    </View>
  );
};

export default DivisionArray;

const styles = StyleSheet.create({
  array: {
    flexDirection: 'row',
    //left: 0,
    //width: '100%',
    margin: 0,
    marginBottom: 20,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },

  arrayRow: {
    borderStyle: 'solid',
    borderWidth: 2,
    borderTopEndRadius: 100,
    borderTopStartRadius: 100,
    borderBottomEndRadius: 100,
    borderBottomStartRadius: 100,
    borderRightColor: '#000',
    margin: 1,
    padding: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  }

});
